import { render, staticRenderFns } from "./buffet-promotion.vue?vue&type=template&id=5f6ec0bd&scoped=true"
import script from "./buffet-promotion.vue?vue&type=script&lang=js"
export * from "./buffet-promotion.vue?vue&type=script&lang=js"
import style0 from "./buffet-promotion.vue?vue&type=style&index=0&id=5f6ec0bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ec0bd",
  null
  
)

export default component.exports